import axios from "axios";
import { get_homepage } from "../../apiConfig";
import { getToken } from "../../../localstorage";

//seo
const api_homepage = async (lang) => {
  try {
    const response = await axios.get(get_homepage, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        lang: lang,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export { api_homepage };
